<template>
	<div class="">
		<!-- 顶栏容器 -->
		<div class="HeadbodyMain1">
			<!-- <div class="headBottomLine"></div> -->
			<div class="logo">
				<router-link to="/">
					<img :src="getLogoConfig.logoImg || defaultTitle" alt style="width: 00px; vertical-align: middle" />
				</router-link>
				<div class="logoText" @click="$router.push('/')">{{ getPlatformName.title }}</div>
			</div>
			<div class="DEFockt">
				<ul>
					<li v-if="Object.keys(this.$store.state.user.userInfo).length === 0 || tokenData == ''">
						<el-button type="text" @click="login">{{ $t('system.homePage.login') }}</el-button>
						<span class="sep">|</span>
						<el-button type="text" @click="register">{{ $t('system.homePage.register') }}</el-button>
					</li>
					<li v-else>
						欢迎
						<el-popover placement="top" width="180" v-model="visible">
							<p>确定退出登录吗？</p>
							<div style="text-align: right; margin: 10px 0 0">
								<el-button size="mini" type="text" @click="visible = false">取消</el-button>
								<el-button type="primary" size="mini" @click="logout">确定</el-button>
							</div>
							<el-button type="text" slot="reference" style="color: #2469f1">
								{{ this.$store.state.user.userInfo.userName }}
							</el-button>
						</el-popover>
					</li>
					<li v-if="Object.keys(this.$store.state.user.userInfo).length !== 0">
						<router-link to="/buyerCenter">个人中心</router-link>
					</li>
					<li>
						<el-button type="text" @click="changeLanguage($t('Language'))">
							<i class="el-icon-sort" style="transform: rotate(90deg)"></i>
							<span>{{ $t('Language') == '中文' ? 'Engilsh' : '中文' }} </span></el-button
						>
					</li>
				</ul>
			</div>
			<div
				@mouseleave="showmsgdigog = false"
				v-show="showmsgdigog"
				style="
					width: 800px;
					padding: 15px;
					overflow: auto;
					height: 685px;
					position: absolute;
					top: 60px;
					right: 300px;
					border-radius: 5px;
					background: #ffffff;
					border: 1px solid #f0f0f0;
					box-shadow: 0 0 15px 0 rgba(0, 64, 134, 0.24);
					z-index: 19961121;
				"
			>
				<i class="el-icon-caret-top" style="position: absolute; top: -20px; right: 30%; font-size: 30px; z-index: 199999; color: rgb(255, 255, 255)"></i>
				<el-tabs v-model="activeName" @tab-click="handleClick">
					<el-tab-pane label="系统消息" name="first">
						<tableTotal
							v-if="sysListConfigTable.tableData.length > 0"
							:index-show="sysListConfigTable.indexShow"
							:config-data="sysListConfigTable.configData"
							:table-data="sysListConfigTable.tableData"
							:loading="sysListConfigTable.loading"
							@handleClick="syshandleClick"
							@selectChange="syshandleSelectionChangeFn"
							@handleSelectionChange="syshandleSelectionChangeFn"
						>
						</tableTotal>
						<el-empty v-if="sysListConfigTable.tableData.length <= 0" description="暂无系统消息"></el-empty>

						<div class="flex-be m-t-20" v-if="sysListConfigTable.tableData.length > 0">
							<!-- <el-button size="small" type="primary" @click="batchDeletionFn">批量删除</el-button> -->
							<div style="width: 50px; height: 20px"></div>
							<el-pagination
								@current-change="sysmsg"
								@size-change="syshandleSizeChange"
								:current-page.sync="sysListConfigTable.current"
								style="float: none"
								layout="total, sizes, prev, pager, next, jumper"
								background
								:page-sizes="[10, 15, 20]"
								:page-size="sysListConfigTable.pageSize"
								:total="sysListConfigTable.total"
							></el-pagination>
						</div>
					</el-tab-pane>

					<el-tab-pane label="待办消息" name="second">
						<tableTotal
							v-if="waitListConfigTable.tableData.length > 0"
							:index-show="waitListConfigTable.indexShow"
							:config-data="waitListConfigTable.configData"
							:table-data="waitListConfigTable.tableData"
							:loading="waitListConfigTable.loading"
							@handleClick="waithandleClick"
							@selectChange="waithandleSelectionChangeFn"
							@handleSelectionChange="waithandleSelectionChangeFn"
						>
						</tableTotal>
						<el-empty v-if="waitListConfigTable.tableData.length <= 0" description="暂无待办消息"></el-empty>

						<div class="flex-be m-t-20" v-if="waitListConfigTable.tableData.length > 0">
							<!-- <el-button size="small" type="primary" @click="batchDeletionFn">批量删除</el-button> -->
							<div style="width: 50px; height: 20px"></div>
							<el-pagination
								@current-change="waitmsg"
								@size-change="waithandleSizeChange"
								:current-page.sync="waitListConfigTable.current"
								style="float: none; !important"
								layout="total, sizes, prev, pager, next, jumper"
								background
								:page-sizes="[10, 15, 20]"
								:page-size="waitListConfigTable.pageSize"
								:total="waitListConfigTable.total"
							></el-pagination>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
		<!-- 顶栏容器END -->
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'
import tableTotal from '@/components/TableTotal/TableTotal'
import Cookie from '../utils/cookie'
import { color } from 'echarts'

export default {
	components: { tableTotal },
	props: {
		type: String
	},
	data() {
		return {
			lanVal: '',
			tokenData: Cookie.get('PIE_MALL_Token'),
			defaultTitle: require('@/assets/imgs/newHome/位图.png'),

			searchMessage: '',
			headertype: '1', //默认为1 控制搜索不同功能样式
			visible: false,
			activeName: 'first',
			showmsgdigog: false,
			// 配置表格
			sysListConfigTable: {
				loading: false,
				indexShow: false,
				configData: [
					// {
					// 	type: 'selection'
					// },
					{
						value: 'content',
						label: '内容',
						align: ' left'
					},
					{
						value: 'ctime',
						label: '创建时间',
						width: '100',
						align: 'left'
					},

					{
						label: '操作',
						width: '220',
						fixed: 'right',
						type: 'handleList',
						align: 'left',
						buttonList: [
							{
								label: '标记已读',
								event: 'onread',
								show: false,
								showText: true,
								text: '确定删除?',
								showCondition: (row) => {
									// 评论状态 0:未读 1:已读
									return row.status === 0
								}
							},
							{
								label: '删除',
								event: 'delete',
								show: true,
								showText: true,
								btnStyle: 'color:red;',
								text: '确定删除?'
							}
						]
					}
				],
				tableData: [],
				current: 1, // 当前页码
				total: 10, // 数据总条数
				pageSize: 10
			},
			waitListConfigTable: {
				loading: false,
				indexShow: false,
				configData: [
					// {
					// 	type: 'selection'
					// },
					{
						value: 'content',
						label: '内容',
						align: ' left'
					},
					{
						value: 'ctime',
						label: '创建时间',
						width: '100',
						align: 'left'
					},

					{
						label: '操作',
						width: '200',
						fixed: 'right',
						type: 'handleList',
						buttonList: [
							{
								label: '查看',
								event: 'seedata',
								show: true,
								showText: true
							}
							// {
							//   label: '删除', event: 'delete', show: true, showText: true,
							//   text: '确定删除?',
							// },
						]
					}
				],
				tableData: [],
				current: 1, // 当前页码
				total: 10, // 数据总条数
				pageSize: 10
			}
		}
	},
	computed: {
		...mapGetters(['getActive', 'getLogoConfig', 'getPlatformName'])
	},
	watch: {
		type: {
			immediate: true,
			handler(newName, oldName) {
				this.headertype = newName
			}
		},
		// 获取vuex的tab选中状态
		getActive: function (val) {
			// console.log('获取vuex的tab选中状态', val)
		}
	},
	mounted() {
		console.log(Cookie.get('PIE_MALL_Token'))
		var that = this
		setTimeout(function () {
			if (Object.keys(that.$store.state.user.userInfo).length != 0) {
				that.sysmsg()
				that.waitmsg()
			}
		}, 500)
	},
	methods: {
		changeLanguage(language) {
			// this.$router.push('/')
			this.lanVal = '中文'
			if (language == '中文') {
				this.lanVal = 'English'
			}
			this.$i18n.locale = this.lanVal
			localStorage.setItem('change-language', this.lanVal == '中文' ? 'zh-CN' : 'en')

			// setTimeout(() => {
			// 	this.testFunc()
			// }, 500)
			// 或直接通过 href 跳转（会刷新）
			window.location.href = this.$router.resolve('/').href
			location.reload()
		},
		testFunc() {
			location.reload()
		},
		handleClick(tab, event) {
			console.log(tab, event, this.activeName)
			this.activeName = tab.name
			if (this.activeName == 'first') {
				this.sysmsg()
			} else {
				this.waitmsg()
			}
		},
		sysmsg() {
			this.sysListConfigTable.loading = true

			this.$http
				.get(
					this.$const.common.userNoticePage,
					{
						page: this.sysListConfigTable.current,
						pageSize: this.sysListConfigTable.pageSize,
						type: 0
					},
					true
				)
				.then((res) => {
					if (res.code == '200') {
						this.sysListConfigTable.tableData = res.data.records
						this.sysListConfigTable.total = res.data.total
						this.sysListConfigTable.loading = false
					}
				})
				.catch((error) => {
					console.log(error, 'error')
				})
		},
		// 表格多选 全选
		syshandleSelectionChangeFn(data) {
			// this.tableSelect = data;
		},
		syshandleSizeChange(val) {
			this.sysListConfigTable.pageSize = val
			this.sysmsg()
		},
		syshandleClick(event, data, text) {
			switch (event) {
				case 'onread':
					this.$http
						.post(this.$const.common.userNoticeRead, [data.noticeId], true)
						.then((res) => {
							if (res.code == '200') {
								this.sysmsg()
							}
						})
						.catch((error) => {
							console.log(error, 'error')
						})
					break
				case 'delete':
					// this.$confirm(text, "提示", {
					// 	confirmButtonText: "确定",
					// 	cancelButtonText: "取消",
					// 	type: "warning",
					// })
					// 	.then(() => {
					this.$http
						.post(this.$const.common.userNoticeDelete, [data.noticeId], true)
						.then((res) => {
							if (res.code == '200') {
								this.sysmsg()
							}
						})
						.catch((error) => {
							console.log(error, 'error')
						})
					// });
					break
			}
		},
		waitmsg() {
			this.waitListConfigTable.loading = true

			this.$http
				.get(
					this.$const.common.userNoticePage,
					{
						page: this.waitListConfigTable.current,
						pageSize: this.waitListConfigTable.pageSize,
						type: 1
					},
					true
				)
				.then((res) => {
					if (res.code == '200') {
						this.waitListConfigTable.tableData = res.data.records
						this.waitListConfigTable.total = res.data.total
						this.waitListConfigTable.loading = false
					}
				})
				.catch((error) => {
					console.log(error, 'error')
				})
		},
		// 表格多选 全选
		waithandleSelectionChangeFn(data) {
			// this.tableSelect = data;
		},
		waithandleSizeChange(val) {
			this.waitListConfigTable.pageSize = val
			this.waitmsg()
		},
		waithandleClick(event, data, text) {
			switch (event) {
				case 'seedata':
					console.log(data.content.substr(0, 2), data.content.substring(data.content.length - 19))
					this.$http
						.post(this.$const.common.userNoticeDelete, [data.noticeId], true)
						.then((res) => {
							if (res.code == '200') {
								this.sysmsg()
							}
						})
						.catch((error) => {
							console.log(error, 'error')
						})

					if (data.content.substr(0, 2) == '买家') {
						this.$router.push({ name: 'SellerCenter', query: { type: 'TransactionList', orderNo: data.content.substring(data.content.length - 19) } })
					} else {
						this.$router.push({ name: 'buyerCenter', query: { type: 'buyerCenter', orderNo: data.content.substring(data.content.length - 19) } })
					}

					break
				case 'delete':
					this.$confirm(text, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(async () => {
						let p = {
							collectId: data.id
						}
						// await this.collectDeleteFn(p);
					})
					break
			}
		},
		// ...mapActions(["setActive"]),
		login() {
			this.$router.push({ path: `/login?redirect=${this.$route.path}` })
			// location.href=window.dataManage.tianhuiLoginUrl+'?url='+window.location.href;
			// location.href='https://www.cpeos.org.cn/personal/login/business?url='+window.location.href;
		},
		register() {
			// location.href='https://www.cpeos.org.cn/personal/register/business?url='+window.location.href;
			// location.href = window.dataManage.tianhuiRegisterUrl + '?url=' + window.location.href;
			this.$router.push({ path: `/register` })
		},
		logout() {
			// this.$store.dispatch("user/loginOut", {});
			Cookie.set('PIE_MALL_Token', '')
			this.$router.push({ path: `/login?redirect=${this.$route.path}` })
			// this.$router.push({ path: `/login?redirect=${this.$route.fullPath}` });
		}
	}
}
</script>

<style lang="scss" scoped>
/* 顶栏容器CSS */
.HeadbodyMain1 {
	width: 100%;
	display: flex;
	//padding: 0 3%;
	// box-shadow: 0px 0px 5px 3px rgba(238, 238, 238, 0.559);
	// background-color:#000;
	position: relative;
	padding: 0 30px;

	.logo {
		display: flex;
		line-height: 60px;
		align-items: center;
		padding-right: 5%;
	}

	.logoText {
		font-size: 1.2vw;
		font-weight: 700;
		color: #1b143c;
		letter-spacing: 1.44px;
		cursor: pointer;
	}

	.so {
		width: 250px;
	}

	.search-frame {
		width: 420px;
		height: 41px;
		display: flex;
		position: relative;
		margin: 29px auto 0;
		border: 2px solid rgb(57, 136, 247);
		border-right: 3px;
	}

	.searchTip {
		position: absolute;
		left: -2px;
		z-index: 999;
		top: 42px;
		width: calc(100% + 4px);
		height: auto;
		padding: 0;
		box-sizing: border-box;
		line-height: 40px;
		background: #edf2f7;
		font-size: 14px;
		color: #757575;
	}

	.searchTip li {
		cursor: pointer;
		text-indent: 10px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.searchTip li:hover {
		background: #ebebeb;
		color: #2469f1;
	}

	.search-frame-input {
		width: 90%;
		padding-left: 15px;
		border: 0;
		outline: none;
	}

	.search-frame-btn {
		cursor: pointer;
		width: 140px;
		text-align: center;
		line-height: 40px;
		background: rgb(57, 136, 247);
	}

	.search-frame-input:focus {
		border: 1px solid rgb(57, 136, 247);
	}

	.me-search-article-item {
		margin-left: auto;
		margin-right: auto;
		width: 90%;
	}

	.search-condition {
		font-size: 16px;
		font-weight: 400;
		color: #fff;
		// color: #333333;
		line-height: 25px;
		cursor: pointer;
		padding-left: 12px;
		padding-right: 12px;
		margin-right: 25px;
	}

	.search-condition:hover {
		background: linear-gradient(92deg, #735dc4, #619ff9 81%, #2469f1);
		border-radius: 13px;
		color: #fff;
		height: 25px;
		display: inline-block;
	}
}

/* 顶栏容器CSS END */
.el-menu.el-menu--horizontal {
	border-bottom: 0px;
}

.el-menu--horizontal > .el-menu-item {
	font-size: 1vw;
	color: #333;
}

.el-menu--horizontal > .el-menu-item.is-active {
	border-bottom: 3px solid #2469f1 !important;
	font-weight: 700;
	color: #2469f1 !important;
}

.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
	color: #2469f1 !important;
	border-bottom: 3px solid #2469f1 !important;
	font-weight: 700;
}

.el-menu--horizontal > .el-menu-item {
	border-bottom: 3px solid transparent;
}

.shopCart-full {
	width: 136px;
	background: #eb4090;
	cursor: pointer;
	padding: 0 7px;

	a {
		color: #fff !important;
	}
}

.shopCart-full a {
	color: white;
}

.shopCart {
	width: 120px;
	background: #fff;
}

.shopCart:hover {
	background: #eee;
}

.shopCart:hover a {
	color: #eb4090;
}

.sep {
	color: #b0b0b0;
	font-size: 12px;
	margin: 0 5px;
}

.DEFockt {
	display: flex;
	flex: 1;

	color: #ffffff93;

	ul {
		flex: 1;

		li {
			float: right;
			line-height: 60px;
			text-align: center;
			margin-left: 20px;
			font-size: 14px;

			.el-button,
			a {
				color: #fff;
			}
		}
	}
}
</style>